export default '/build/993d0d5b.svg'